import { takeLatest, put, call, fork } from "redux-saga/effects";
import { updateCaseMeta, updateCaseMasterLedgers } from "services/case-service";
import { updatedCaseMeta, failedUpdateCaseMeta, fetchCaseDetail } from "store/actions";
import { CASE_META_ACTIONS } from "constants";
import { message } from "antd";

function* updateCaseAndCompanyMetaInfo({ payload }) {
    try {
        const { data: { ledger_masters, ...restData }} = payload;
        const caseMeta = yield call(updateCaseMeta, payload.caseId, restData);
        if(!caseMeta.error) {
            const result = yield call(updateCaseMasterLedgers, payload.caseId, ledger_masters);
            const noError = result.data;
            if(noError) {
                yield put(updatedCaseMeta(payload.caseId));
                yield put(fetchCaseDetail(payload.caseId));
            } else {
                yield put(failedUpdateCaseMeta(payload.caseId));
                yield put(fetchCaseDetail(payload.caseId));
            }
        }
        
    } catch(error) {
        if(error.non_field_errors) {
            error.non_field_errors.map(_ => {
                message.error(_, 5);
            });
        }
        if(error[0] && error[0].non_field_errors) {
            error[0].non_field_errors.map(_ => {
                message.error(_, 5);
            });
        }
        yield put(failedUpdateCaseMeta(payload.caseId));
        // yield put(fetchCaseDetail(payload.caseId));
    }
}


export default fork(function* () {
    yield takeLatest(CASE_META_ACTIONS.UPDATE_CASE_META, updateCaseAndCompanyMetaInfo);
});